import { useCallback, useContext, useEffect, useState } from "react";
import { configStore } from "../../../../../contexts/ConfigContext";
import { sessionStore } from "../../../../../contexts/SessionContext";
import useLearningSets from "../../useLearningSets";
import { Loader, LoaderStatus } from "../../../../../interfaces/Status";
import {
    Experimentation,
    ExperimentationSet,
    Test,
    TestProgress,
} from "../../type";
import { axiosClient } from "../../../../../utils/axios-client/axios-client";
import * as localStorage from "../../../../../utils/localStorage";
import { flattenPool } from "../../utils";
const useTeacherTests = () => {
    const {
        config: { mode, apiUrls },
    } = useContext(configStore);
    const {
        session: { userId },
    } = useContext(sessionStore);

    const learningSets = useLearningSets();

    const [tests, setTests] = useState<Loader<Experimentation[]>>({
        status: LoaderStatus.Loading,
    });

    const getTests = useCallback(
        async (
            learningSets: ExperimentationSet<Test>[],
            preTestsIds: string[]
        ) => {
            const headers = {
                Authorization: `Bearer ${localStorage.getItem(
                    localStorage.Key.TOKEN
                )}`,
                "x-evidenceb-app": "athena",
                "Content-Type": "application/json",
                "x-evb-origin": window.location.origin,
            };
            try {
                const data = await Promise.all(
                    learningSets.map(async (learningSet) => {
                        const response =
                            await axiosClient.axios.get<TestProgress>(
                                `${apiUrls.endpoints.analytics!}/test/${
                                    learningSet.learning_set_id
                                }/?teacher_id=${userId}`,
                                { headers }
                            );
                        return {
                            data: learningSet,
                            results: undefined,
                            averageProgress: response.data.average_progress,
                            classroomsProgress:
                                response.data.classrooms_progress,
                            isPretest: preTestsIds.includes(
                                learningSet.learning_set_id
                            ),
                        };
                    })
                );
                setTests({
                    status: LoaderStatus.Success,
                    payload: data,
                });
            } catch (err) {
                setTests({
                    status: LoaderStatus.Error,
                    err: "callTests failed " + err,
                });
            }
        },
        [apiUrls.endpoints.analytics, userId]
    );

    useEffect(() => {
        if (!mode?.test || learningSets.status === LoaderStatus.Error)
            return setTests({
                status: LoaderStatus.Error,
                err: `${
                    learningSets.status === LoaderStatus.Error
                        ? "No learningSets"
                        : "Mode is not defined"
                }`,
            });
        if (learningSets.status === LoaderStatus.Success) {
            const preTestsIds = flattenPool(mode.test.pre) ?? [];
            getTests(learningSets.payload, preTestsIds);
        }
    }, [apiUrls.endpoints.analytics, getTests, learningSets, mode, userId]);

    return tests;
};

export default useTeacherTests;
